import React from 'react';
import { TextField, MenuItem } from '@material-ui/core';

import useCars from '../../../../context/useCars';
import { useDropOffCities } from 'queries';
import { useTranslations } from 'components/utilities';

const DropCitySelect = () => {
	const { t } = useTranslations();

	const {
		dropInDifferentCity,
		dropCity,
		handleDropCityChange,
		airport,
	} = useCars();

	const { data: dropOffCityList } = useDropOffCities(airport.placeId);

	const handleChange = (ev) => {
		const uuid = ev.target.value;

		const dropCity = dropOffCityList.find((dropCity) => dropCity.uuid === uuid);

		handleDropCityChange(dropCity);
	};

	return (
		<TextField
			select
			variant="outlined"
			size="small"
			color="primary"
			label={t('cars.selectCityPlaceholder')}
			value={dropCity ? dropCity.uuid : ''}
			onChange={handleChange}
			fullWidth
			disabled={!dropInDifferentCity}
		>
			{dropOffCityList.map(({ name, uuid }) => (
				<MenuItem key={uuid} value={uuid}>
					{name}
				</MenuItem>
			))}
		</TextField>
	);
};

export default DropCitySelect;
